import FormattedMessage from 'I18n/components/FormattedMessage';
import { RolloutStates } from '../RolloutTypes';
import RolloutProductUpdateStatusTagBeta from './RolloutProductUpdateStatusTagBeta';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RolloutProductUpdateStatusTag({
  id,
  rolloutId,
  title,
  untranslatedTitle,
  gate,
  rolloutState,
  enrollmentStatus,
  enrollType,
  betaPaused
}) {
  let statusTagProps = {};
  switch (rolloutState) {
    case RolloutStates.PRIVATE_BETA:
    case RolloutStates.PUBLIC_BETA:
      return /*#__PURE__*/_jsx(RolloutProductUpdateStatusTagBeta, {
        id: id,
        rolloutId: rolloutId,
        title: title,
        untranslatedTitle: untranslatedTitle,
        gate: gate,
        enrollmentStatus: enrollmentStatus,
        enrollType: enrollType,
        betaPaused: betaPaused,
        rolloutState: rolloutState
      });
    case RolloutStates.IN_DEVELOPMENT:
      statusTagProps = {
        use: 'default'
      };
      break;
    case RolloutStates.LIVE:
      statusTagProps = {
        use: 'success'
      };
      break;
    case RolloutStates.PHASED_ROLLOUT:
      statusTagProps = {
        use: 'success',
        hollow: true
      };
      break;
    case RolloutStates.SUNSET:
      statusTagProps = {
        use: 'danger'
      };
      break;
    case RolloutStates.UPCOMING_SUNSET:
      statusTagProps = {
        use: 'danger',
        hollow: true
      };
      break;
    default:
      break;
  }
  return statusTagProps ? /*#__PURE__*/_jsx(StatusTag, {
    hollow: statusTagProps.hollow,
    use: statusTagProps.use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `app.statusTags.${rolloutState}`
    })
  }) : null;
}